export default __webpack_public_path__ + "static/media/icon-pinterest.fd8b84da.svg";